import React from 'react'
import { TiSocialFacebook } from 'react-icons/ti';
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

function Content({ jobDetail }) {
    console.log(jobDetail)
    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Get current page URL for sharing
    const currentUrl = window.location.href;
    const shareTitle = jobDetail?.title || 'Job Opportunity';
    const shareText = `Check out this job: ${shareTitle}`;

    // Share functions for different platforms
    const shareOnFacebook = () => {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
        window.open(url, '_blank', 'width=600,height=400');
    };

    const shareOnTwitter = () => {
        const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(shareText)}`;
        window.open(url, '_blank', 'width=600,height=400');
    };

    const shareOnWhatsApp = () => {
        const url = `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + currentUrl)}`;
        window.open(url, '_blank');
    };

    const shareOnLinkedIn = () => {
        const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`;
        window.open(url, '_blank', 'width=600,height=400');
    };
    return (
        <section className="job-details-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="job-details-wrap">
                            <div className="job-details-info">

                                <div className="content">
                                    <h4 className="title">{jobDetail?.title}</h4>
                                    <h5 className="sub-title">{jobDetail?.hospital_name}</h5>
                                    <ul className="info-list">
                                        <li><i className="icofont-location-pin" /> {jobDetail?.city_code}</li>
                                        {/* <li><i className="icofont-phone" /> +88 456 796 457</li> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="job-details-price">
                                <a href={jobDetail?.webSiteLink} target="_blank" rel="noopener">
                                    <button type="button" className="btn-theme">Apply Now</button>

                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-7 col-xl-8">
                        <div className="job-details-item" >
                            <div className="content">
                                <h4 className="title">Description</h4>
                                <div dangerouslySetInnerHTML={{ __html: jobDetail?.scholarshipDescription }} />
                            </div>
                        </div>


                    </div>
                    <div className="col-lg-5 col-xl-4">
                        <div className="job-sidebar">
                            <div className="widget-item">
                                <div className="widget-title">
                                    <h3 className="title">Summary</h3>
                                </div>
                                <div className="summery-info">
                                    <table className="table">
                                        <tbody>
                                            <tr>
                                                <td className="table-name">Subject</td>
                                                <td className="dotted">:</td>
                                                <td data-text-color="#03a84e">{jobDetail?.subject}</td>
                                            </tr>
                                            <tr>
                                                <td className="table-name">Collage/University</td>
                                                <td className="dotted">:</td>
                                                <td>{jobDetail?.collageUniversty}</td>
                                            </tr>
                                            <tr>
                                                <td className="table-name">Posted</td>
                                                <td className="dotted">:</td>
                                                <td>{formatDate(jobDetail?.createdAt)}</td>
                                            </tr>

                                            <tr>
                                                <td className="table-name">Fee</td>
                                                <td className="dotted">:</td>
                                                <td>{jobDetail?.fee} PKR / Monthly</td>
                                            </tr>
                                            {/* <tr>
                      <td className="table-name">Experience</td>
                      <td className="dotted">:</td>
                      <td>05 Years</td>
                    </tr>
                    <tr>
                      <td className="table-name">Gender</td>
                      <td className="dotted">:</td>
                      <td>Male or Female</td>
                    </tr> */}
                                            {/* <tr>
                      <td className="table-name">Qualification</td>
                      <td className="dotted">:</td>
                      <td>BSC, MSC</td>
                    </tr> */}
                                            {/* <tr>
                      <td className="table-name">Level</td>
                      <td className="dotted">:</td>
                      <td>Senior</td>
                    </tr> */}
                                            {/* <tr>
                      <td className="table-name">Applied</td>
                      <td className="dotted">:</td>
                      <td>26 Applicant</td>
                    </tr> */}
                                            {/* <tr>
                      <td className="table-name">Application End</td>
                      <td className="dotted">:</td>
                      <td data-text-color="#ff6000">20 November, 2022</td>
                    </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="widget-item">
                                <div className="widget-title">
                                    <h3 className="title">Share On Social Media</h3>
                                </div>
                                <div className="social-icons">
                                    <a href="#" onClick={(e) => { e.preventDefault(); shareOnFacebook(); }} rel="noopener">
                                        <TiSocialFacebook style={{ fontSize: "25px" }} />
                                    </a>
                                    <a href="#" onClick={(e) => { e.preventDefault(); shareOnTwitter(); }} rel="noopener">
                                        <BsTwitterX style={{ fontSize: "20px" }} />
                                    </a>
                                    <a href="#" onClick={(e) => { e.preventDefault(); shareOnWhatsApp(); }} rel="noopener">
                                        <FaWhatsapp style={{ fontSize: "20px" }} />
                                    </a>
                                    <a href="#" onClick={(e) => { e.preventDefault(); shareOnLinkedIn(); }} rel="noopener">
                                        <FaLinkedinIn />
                                    </a>
                                </div>
                            </div>
                            {/* <div className="widget-item widget-tag">
              <div className="widget-title">
                <h3 className="title">Tags:</h3>
              </div>
              <div className="widget-tag-list">
                <a href="job.html">Cleaning</a>
                <a href="job.html">Cleaning Agency</a><br />
                <a href="job.html">Business</a>
                <a href="job.html">Cleaning</a>
                <a href="job.html">Business</a>
                <a href="job.html">Cleaning</a>
                <a href="job.html">Cleaning Agency</a>
                <a href="job.html">Business</a>
                <a href="job.html">Cleaning Agency</a>
                <a href="job.html">Cleaning</a>
                <a href="job.html">Business</a>
                <a href="job.html">Business</a>
                <a href="job.html">Cleaning Agency</a>
                <a href="job.html">Business</a>
              </div>
            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Content